import { render, staticRenderFns } from "./MapBackground.vue?vue&type=template&id=b4cc7736&scoped=true&lang=pug&"
import script from "./MapBackground.vue?vue&type=script&lang=js&"
export * from "./MapBackground.vue?vue&type=script&lang=js&"
import style0 from "./MapBackground.vue?vue&type=style&index=0&id=b4cc7736&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cc7736",
  null
  
)

component.options.__file = "MapBackground.vue"
export default component.exports